import { useWebsiteSettings } from 'client/store'
import { updateWebsite } from 'src/editor/api/website-websites-api'
import { useUpdateStoreObject } from 'src/editor/shared/hooks/use-update-store'
import {
  setWebsiteDraftTheme,
  setWebsiteTheme,
} from 'src/editor/store/website-settings/website-settings-actions'
import {
  getWebsiteDraftTheme,
  getWebsiteLocale,
  getWebsiteName,
  getWebsiteStyles,
  getWebsiteTheme,
} from 'src/editor/store/website-settings/website-settings-selector'
import { transformWebsiteTheme } from '../website/utils/transform-website-theme'

export const useWebsiteSave = () => {
  const websiteDraftTheme = useWebsiteSettings(getWebsiteDraftTheme)
  const websiteTheme = useWebsiteSettings(getWebsiteTheme)
  const websiteStyles = useWebsiteSettings(getWebsiteStyles)
  const updateWebsiteDraftTheme = useUpdateStoreObject(setWebsiteDraftTheme)
  const updateWebsiteTheme = useUpdateStoreObject(setWebsiteTheme)
  const websiteName = useWebsiteSettings(getWebsiteName)
  const websiteDefaultLocale = useWebsiteSettings(getWebsiteLocale)

  const save = async (websiteId: number) => {
    const theme = websiteDraftTheme ?? websiteTheme
    if (theme) {
      const response = await updateWebsite(websiteId, {
        name: websiteName,
        defaultLocale: websiteDefaultLocale,
        style: websiteStyles,
        theme: transformWebsiteTheme(theme),
      })

      if (websiteDraftTheme) {
        updateWebsiteTheme(response.theme)
        updateWebsiteDraftTheme(null)
      }
    }
  }

  return save
}
